import { ChevronRight, Close } from '@mui/icons-material';
import { Box, Button, Grid, IconButton, List, ListItem, ListItemText, Paper, TextField } from '@mui/material';
import React, { Component } from 'react';
import axios from "axios";
import Global from "../../../customlib/Global";
import Api from "../../../customlib/Api";

class CustomerOwnerSelector extends Component {
    state = {
        listUsers: [],
        keyword: "",
    }

    componentDidMount() {
        this.getLavengerUsers();
    }

    notifySelection = () => {
        const ownerIds = this.state.listUsers.filter(user => user.isSelected === true).map(user => user.id);
        if (this.props.onSelectionChange) {
            this.props.onSelectionChange(ownerIds);
        }
    }

    getLavengerUsers = () => {

        const params = {
            appProfileId: Global.getAppProfile()._id
        };

        axios
            .post(Api.lavengerUsersList(), params, Api.getRequestHeader())
            .then((response) => {

                console.log("LAVENGER USERS : ", response.data);

                var users = response.data.data;

                const customerOwnerIds = this.props.customerOwnerIds || [];

                users.forEach(user => {
                    // user.isSelected = true;
                    const find = customerOwnerIds.find(selected => user.id === selected);
                    if(find){
                        user.isSelected = true;
                    }else{
                        user.isSelected = false;
                    }
                });

                this.setState({ listUsers: users }, this.notifySelection);
            })
            .catch((error) => {
                console.error("There was an error!", error);
            });
    };

    handleSelectUser = (userData) => {
        const listUsers = [...this.state.listUsers];

        const findUser = listUsers.find(item => item.id === userData.id);

        if(findUser){
            findUser.isSelected = true;
        }

        this.setState({listUsers: listUsers}, this.notifySelection);
    }

    handleUnselectUser = (userData) => {
        const listUsers = [...this.state.listUsers];

        const findUser = listUsers.find(item => item.id === userData.id);

        if(findUser){
            findUser.isSelected = false;
        }

        this.setState({listUsers: listUsers}, this.notifySelection);
    }

    handleKeywordChanged = (event) => {
        this.setState({keyword: event.target.value});
    }

    filterUserLavender = (keyword) => {
        return this.state.listUsers.filter(user => user.isSelected !== true &&
            (
                user.email.toLowerCase().includes(`${keyword}`.toLowerCase()) ||
                user.name.toLowerCase().includes(`${keyword}`.toLowerCase())
            )
        );
    }

    handleClearSelection = () => {
        const listUsers = [...this.state.listUsers];
        listUsers.forEach(item => item.isSelected = false);

        this.setState({listUsers: listUsers}, this.notifySelection);
    }

    render() {
        return (
            <Paper elevation={1} sx={{mt: "10px", p: "5px"}}>
                <Grid container spacing={1}>
                    <Grid item xs={4}>
                        <TextField
                            id="txt-keyword-lavender"
                            label="pencarian owner customer"
                            variant="outlined"
                            type='text'
                            onChange={this.handleKeywordChanged}
                            value={this.state.keyword}
                            fullWidth
                            size='small'
                        />
                        <List style={{ maxHeight: "30vh", overflowY: "scroll", marginTop: "10px" }}>
                        {
                            // this.state.listUsers.filter(user => user.isLavengerUser === false).map(user =>
                            this.filterUserLavender(this.state.keyword).map(user =>
                                (
                                    <ListItem sx={{ cursor: "pointer" }} dense key={user.id} onClick={() => { this.handleSelectUser(user) }}
                                        secondaryAction={
                                            // <IconButton edge="end" aria-label="delete">
                                            <ChevronRight style={{ marginTop: 5 }} />
                                            // </IconButton>
                                        }
                                    >
                                        <ListItemText
                                            primary={user.name}
                                            secondary={user.email}
                                        />
                                    </ListItem>
                                )
                            )
                        }
                    </List>
                    </Grid>
                    <Grid item xs={8}>
                        <Box sx={{mt: "8px", ml: "10px"}}>
                            <Grid container spacing={1}>
                                <Grid item xs={10}>
                                    <strong>Blast customer dengan owner sebagai berikut :</strong>
                                </Grid>
                                <Grid item xs={2} textAlign={"right"}>
                                    {
                                        this.state.listUsers.filter(user => user.isSelected === true).length > 0 && (
                                            <Button
                                                color='warning'
                                                variant='outlined'
                                                size='small'
                                                onClick={this.handleClearSelection}
                                                sx={{textTransform: "capitalize"}}
                                            >
                                                Clear All
                                            </Button>
                                        )
                                    }

                                </Grid>
                            </Grid>
                        </Box>
                        <Box sx={{mt: "10px",ml: "10px"}}>
                            <Grid container spacing={1}>
                            {
                                // this.state.listUsers.filter(user => user.isLavengerUser === false).map(user =>
                                this.state.listUsers.filter(user => user.isSelected === true).map(user =>
                                    (
                                        <Grid item xs={4}>
                                            <Box sx={{border: "solid 1px #1c04f87c", p: "5px", borderRadius: "5px", backgroundColor: "#96c0fb47" }}>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={10}>
                                                        <Box sx={{fontSize: "11px",fontWeight: "bold"}}>{user.name}</Box>
                                                        <Box sx={{fontSize: "10px"}}>{user.email}</Box>
                                                    </Grid>
                                                    <Grid item xs={2} textAlign={"right"}>
                                                        <IconButton
                                                            size='small'
                                                            color='error'
                                                            onClick={() => this.handleUnselectUser(user)}
                                                        >
                                                                <Close sx={{width: "15px", height: "15px"}} />
                                                        </IconButton>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Grid>
                                    )
                                )
                            }
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        );
    }
}

export default CustomerOwnerSelector;
